// Lage im Haus (z. B. "EG L", "2. OG R") für ETW-Immobilien aus der
// zugehörigen Mieteinheit ableiten — für Listen, Badges & Dropdowns.
//
// Die Lage wird bewusst *abgeleitet* und nicht als Feld gespeichert: ändert
// sich das unit_label der Haupt-Mieteinheit, stimmt die Anzeige automatisch.

const MAIN_TYPES = ["wohnung", "gewerbe"];

// Seitenangaben werden abgekürzt, damit die Zeilen in Listen und Dropdowns
// kurz bleiben.
const SIDE_SHORT = { links: "L", rechts: "R", mitte: "M" };

export const unitLage = (label) => {
    if (!label) return null;
    let text = label;
    for (const sep of ["—", "–"]) {
        if (text.includes(sep)) text = text.split(sep).pop();
    }
    text = text.trim();
    return text || label.trim() || null;
};

/**
 * Lage als kompakter Positionscode, ohne Leerzeichen:
 *   "EG links"      → "EGL"
 *   "1. OG rechts"  → "1.OGR"
 *   "1. OG Mitte"   → "1.OGM"
 *   "DG links"      → "DGL"
 *   "DG"            → "DG"
 *
 * Im Bestand kommen "1.OG" und "1. OG" gemischt vor — beides wird auf "1.OG"
 * normalisiert. Zusätze, die keine Seitenangabe sind (z. B. "EG Anbau"),
 * behalten ihr Leerzeichen, sonst würde daraus das schwer lesbare "EGAnbau".
 */
export const shortLage = (lage) => {
    if (!lage) return null;
    let t = String(lage).trim().replace(/\s+/g, " ");
    t = t.replace(/(\d+)\s*\.\s*OG/i, "$1.OG");
    t = t.replace(/\s*\b(links|rechts|mitte)\b/gi, (_, w) => SIDE_SHORT[w.toLowerCase()]);
    return t || null;
};

/**
 * property_id → Lage.
 * @param short  true (Default) = gekürzt für die Anzeige, false = Originaltext.
 *               Die Langform wird für die Volltextsuche gebraucht, damit
 *               "links" weiterhin findet, was als "L" angezeigt wird.
 */
export const buildLageMap = (properties, units, { short = true } = {}) => {
    const byProp = {};
    (units || []).forEach((u) => {
        if (!byProp[u.property_id]) byProp[u.property_id] = [];
        byProp[u.property_id].push(u);
    });
    const map = {};
    (properties || []).forEach((p) => {
        if (p.asset_typ !== "ETW") return;
        const us = byProp[p.id] || [];
        const main = us.filter((u) => MAIN_TYPES.includes(u.typ) && !u.parent_unit_id);
        const src = main[0] || us[0];
        const raw = src ? unitLage(src.unit_label) : null;
        const lage = short ? shortLage(raw) : raw;
        if (lage) map[p.id] = lage;
    });
    return map;
};

export const propertyDisplay = (p, lageMap = {}) => {
    if (!p) return "";
    const base = p.label || p.address || "";
    const lage = lageMap[p.id];
    return lage ? `${base} – ${lage}` : base;
};
